const BUSINESS_TYPES = [
  {
    label: "Landwirtschaftlicher Händler / Bauernladen",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Tierheim / Wohltätigkeitsorganisation",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Aufzuchtbetrieb",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Rindfleischproduzent",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Masthähnchen", value: "Broilers", id: "broilers" },
  {
    label: "Einkaufsgruppe",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Kälberproduktion",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Kälberfarm/Entwickler",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Viehkäufer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Vertragszüchter",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Genossenschaft", value: "Cooperative", id: "cooperative" },
  {
    label: "Unternehmenszentrale",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Mutterkuhhaltung",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Milchproduktion",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Händler / Vertreter",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Futtermühle", value: "Feed Mill", id: "feed_mill" },
  { label: "Mastbetrieb", value: "Feedyard", id: "feedyard" },
  {
    label: "Mäster/Aufzuchtbetrieb",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Brüterei", value: "Hatchery", id: "hatchery" },
  {
    label: "Färsenproduktion",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Legehennenintegration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Legehennen", value: "Layers", id: "layers" },
  { label: "Medien", value: "Media", id: "media" },
  {
    label: "Milchgenossenschaft/Käufer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Gemischter/Anderer Produzent",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nährstofflieferant",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Verpacker/Verarbeiter",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Zoofachhandel",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Apotheke", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Geflügelzüchter",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Geflügelintegrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Schafzüchter", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Aufzuchtbetrieb",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Viehhof/Verkaufsstall",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Schweineproduzent", value: "Swine Producer", id: "swine_producer" },
  { label: "Puten", value: "Turkeys", id: "turkeys" },
  {
    label: "Universität / Bildung",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Tierarztpraxis",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Großhändler / Einzelhändler",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wollkäufer", value: "Wool Buyer", id: "wool_buyer" },
];
const FIELDS = {
  common: {
    errors: {
      required: "Erforderlich",
    },
  },
  salutation: {
    label: "Anrede",
    placeholder: "Anrede auswählen",
    errors: {
      required: "Anrede ist erforderlich",
      invalid: "Bitte wählen Sie eine gültige Anrede",
    },
  },
  firstName: {
    label: "Vorname",
    placeholder: "Max",
    errors: {
      authenticatedNameUpdateTrial:
        "Sie sind angemeldet und Ihr Name kann nicht geändert werden.",
      required: "Vorname ist erforderlich",
      minLength: "Vorname muss mindestens 2 Zeichen lang sein",
      maxLength: "Vorname darf maximal 50 Zeichen lang sein",
    },
  },
  lastName: {
    label: "Nachname",
    placeholder: "Mustermann",
    errors: {
      authenticatedNameUpdateTrial:
        "Sie sind angemeldet und Ihr Name kann nicht geändert werden.",
      required: "Nachname ist erforderlich",
      minLength: "Nachname muss mindestens 2 Zeichen lang sein",
      maxLength: "Nachname darf maximal 50 Zeichen lang sein",
    },
  },
  email: {
    label:
      "E-Mail-Adresse (Bitte geben Sie Ihre persönliche E-Mail-Adresse an)",
    placeholder: "max.mustermann@example.org",
    description:
      "Bitte geben Sie eine E-Mail-Adresse ein, die persönlich für Sie ist, keine gemeinsam genutzte E-Mail-Adresse.",
    prefixWarningTitle: "Gemeinsames Postfach erkannt",
    prefixWarningDescription:
      "Wir empfehlen die Verwendung einer persönlichen E-Mail-Adresse für ein besseres personalisiertes Erlebnis",
    errors: {
      authenticatedEmailUpdateTrial:
        "Sie sind angemeldet und Ihre E-Mail-Adresse kann nicht geändert werden.",
      required: "E-Mail ist erforderlich",
      invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      emailAssociatedWithYourAccount:
        "Ihre E-Mail-Adresse ist mit Ihrem Konto verknüpft und kann nicht geändert werden.",
    },
  },
  confirmEmail: {
    label:
      "E-Mail-Adresse bestätigen (Bitte geben Sie Ihre persönliche E-Mail-Adresse an)",
    placeholder: "max.mustermann@example.org",
    errors: {
      authenticatedEmailUpdateTrial:
        "Sie sind angemeldet und Ihre E-Mail-Adresse kann nicht geändert werden.",
      required: "E-Mail-Bestätigung ist erforderlich",
      invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      emailMatchError: "E-Mail-Adressen stimmen nicht überein",
    },
  },
  password: {
    label: "Passwort",
    placeholder: "Geben Sie Ihr Passwort ein",
    errors: {
      required: "Passwort ist erforderlich",
    },
  },
  confirmPassword: {
    label: "Passwort bestätigen",
    placeholder: "Bestätigen Sie Ihr Passwort",
    errors: {
      required: "Passwortbestätigung ist erforderlich",
      passwordMatchError: "Passwörter stimmen nicht überein",
    },
  },
  addressLine1: {
    label:
      "Straße und Hausnummer (Standort der Tierarztpraxis/Tierklinik/Institution)",
    placeholder: "Straße und Hausnummer",
    errors: {
      required: "Adresse Zeile 1 ist erforderlich",
      minLength: "Adresse Zeile 1 muss mindestens 5 Zeichen lang sein",
      maxLength: "Adresse Zeile 1 darf maximal 100 Zeichen lang sein",
    },
  },
  addressLine2: {
    label: "Adresse Zeile 2",
    placeholder: "Wohnung 4B",
    errors: {
      required: "Adresse Zeile 2 ist erforderlich",
      maxLength: "Adresse Zeile 2 darf maximal 100 Zeichen lang sein",
    },
  },
  city: {
    label: "Stadt (Standort der Tierarztpraxis/Tierklinik/Institution)",
    placeholder: "Stadt",
    errors: {
      required: "Stadt / Ort ist erforderlich",
      minLength: "Stadt / Ort muss mindestens 2 Zeichen lang sein",
      maxLength: "Stadt / Ort darf maximal 50 Zeichen lang sein",
    },
  },
  country: {
    label: "Land",
    placeholder: "Land auswählen",
    errors: {
      required: "Land ist erforderlich",
      invalid: "Bitte wählen Sie ein gültiges Land aus",
    },
  },
  state: {
    label: "Bundesland",
    placeholder: "Bundesland auswählen",
    errors: {
      required: "Bundesland ist erforderlich",
      invalid: "Bitte wählen Sie ein gültiges Bundesland",
    },
  },
  jurisdiction: {
    label: "Zuständigkeit der Lizenz",
    placeholder: "Zuständigkeit der Lizenz auswählen",
    errors: {
      required: "Zuständigkeit der Lizenz ist erforderlich",
      invalid: "Bitte wählen Sie eine gültige Zuständigkeit",
    },
  },
  zipCode: {
    label: "Postleitzahl (Standort der Tierarztpraxis/Tierklinik/Institution)",
    placeholder: "Postleitzahl",
    errors: {
      required: "Postleitzahl ist erforderlich",
      invalid: "Bitte geben Sie eine gültige Postleitzahl ein",
    },
  },
  role: {
    label: "Rolle",
    placeholder: "Wählen Sie Ihre Rolle",
    errors: {
      required: "Bitte wählen Sie Ihre Rolle",
      invalid: "Bitte wählen Sie eine gültige Rolle",
    },
  },
  businessType: {
    label: "Geschäftstyp",
    placeholder: "Geschäftstyp auswählen",
    errors: {
      required: "Geschäftstyp ist erforderlich",
      invalid: "Bitte wählen Sie einen gültigen Geschäftstyp",
    },
  },
  businessName: {
    label: "Name der Tierarztpraxis/Tierklinik/Institution",
    placeholder: "Name der Tierarztpraxis/Tierklinik/Institution",
    errors: {
      required: "Firmenname ist erforderlich",
      minLength: "Firmenname muss mindestens 2 Zeichen lang sein",
      maxLength: "Firmenname darf maximal 100 Zeichen lang sein",
    },
  },
  businessSearch: {
    label: "Firmensuche:",
    addNewAccount: "Neues Geschäftskonto hinzufügen",
    canNotFindBusiness: "Sie finden Ihr Unternehmen nicht?",
    guideline:
      "Bitte geben Sie Ihre Postleitzahl ein und wählen Sie dann aus der Liste unten.",
    guidelineForNameSearch:
      "Bitte geben Sie den vollständigen Firmennamen ein und wählen Sie dann aus der Liste.",
    placeholder: "Wo arbeiten Sie?",
    noResults: "Keine Ergebnisse gefunden",
    searching: "Suchen...",
    selectedBusinessHeading: "Ausgewähltes Unternehmen:",
    selectedBusinessNotCorrect: "Nicht korrekt?",
    selectedBusinessTryAgain: "Erneut versuchen",
    selectedBusinessDismiss: "Unternehmen verwerfen",
    resultsFound: {
      singular: "1 Unternehmen gefunden",
      plural: "Mehrere Unternehmen gefunden",
    },
    errors: {
      network:
        "Wir haben Probleme, eine Verbindung zum Unternehmenssuchfinder herzustellen. Bitte versuchen Sie es später erneut.",
    },
  },
  explicitConsent: {
    label:
      "Indem ich dieses Kästchen ankreuze, stimme ich zu, Marketingmitteilungen von Elanco zu erhalten.",
    errors: {
      required: "Zustimmung ist erforderlich",
    },
  },
  explicitSmsConsent: {
    label:
      "Indem ich dieses Kästchen ankreuze, stimme ich zu, Marketingmitteilungen von Elanco per SMS/Textnachricht zu erhalten.",
    errors: {
      required: "Die Einwilligung für SMS ist erforderlich",
    },
  },
  telephone: {
    label: "Persönliche Telefonnummer",
    placeholder: "Geben Sie Ihre persönliche Telefonnummer ein",
    dialCodeLabel: "Vorwahl",
    dialCodePlaceholder: "Land suchen…",
    errors: {
      invalid: "Bitte geben Sie eine gültige Telefonnummer ein.",
    },
  },
  businessTelephone: {
    label: "Geschäftliche Telefonnummer",
    placeholder: "Geben Sie Ihre geschäftliche Telefonnummer ein",
    dialCodeLabel: "Vorwahl",
    dialCodePlaceholder: "Land suchen…",
    errors: {
      invalid: "Bitte geben Sie eine gültige Telefonnummer ein.",
    },
  },
  professionalNumber: {
    label: "Berufsnummer",
    placeholder: "1234567",
    errors: {
      required: "Bitte geben Sie eine Berufsnummer ein",
      maxLength: "Eingabe überschreitet die Zeichenbegrenzung",
    },
  },
  addressSearch: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  businessSearchField: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  checkbox: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  combobox: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  datePicker: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  dateRange: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  dateTime: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  emailField: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  fileInput: {
    errors: {
      required: "Bitte wählen Sie eine Datei aus",
    },
  },
  number: {
    errors: {
      required: "Bitte geben Sie eine Zahl ein",
      minValue: "Bitte geben Sie einen Wert höher als das Minimum ein",
      maxValue: "Bitte geben Sie einen Wert niedriger als das Maximum ein",
    },
  },
  passwordField: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  rangeSlider: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  select: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  telephoneField: {
    errors: {
      required: "Bitte geben Sie nur Zahlen ein",
      invalidTelephone: "Bitte geben Sie eine gültige Telefonnummer ein",
      invalidFormat: "Ungültiges Zahlenformat",
    },
  },
  text: {
    errors: {
      required:
        "Bitte verwenden Sie nur Buchstaben (A-Z), Zahlen (0-9) und keine Symbole",
      maxLength: "Die Eingabe überschreitet die Zeichenbegrenzung",
      minLength: "Die Eingabe muss mindestens 2 Zeichen lang sein",
    },
  },
  textarea: {
    characters: "Zeichen",
  },
  time: {
    errors: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  form: {
    errors: {
      generic:
        "Bei der Übermittlung Ihres Formulars ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      reportAnIssue: "Bitte melden Sie ein Problem.",
      configuration: "Konfigurationsfehler",
      noFormQuestionsAvailable: "Keine Formularfragen verfügbar.",
      formComponentLoad:
        "Formularkomponente konnte nicht geladen werden, aufgrund eines nicht unterstützten Feldes.",
      code: "Code",
      type: "Typ",
      missingRequiredFields:
        "Diesem Formular fehlen erforderliche Felder (E-Mail und/oder Einwilligung). Bitte kontaktieren Sie einen Administrator, um die Formularkonfiguration zu korrigieren.",
    },
  },
};
const ROLES = [
  { value: "Academic", label: "Akademiker", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Tierschutz - Sonstige",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Tierschutz - Verkaufspersonal",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Tierschutz - Tierarzt",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Tierschutz - Tierarzthelferin",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Tierschutz - Freiwilliger",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Rindfleisch / Mastbetriebsberatung",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Rindfleischproduzent",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Züchter", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Geschäftsadministrator / Rezeptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Geschäftsinhaber / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Beratender Ernährungsberater",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Mitarbeiter im Unternehmen (nicht Tierarzt)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Milchproduzent",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Händler", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Vertriebsmitarbeiter, Außendienst",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Vertriebsmitarbeiter, Innendienst",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Bildungseinrichtung - Gymnasiast",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Bildungseinrichtung - TAFE-Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Bildungseinrichtung - Universitätsstudent",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Tierfriseur", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medizinischer / Klinikdirektor",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Ernährung / Futtermittelverkauf",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Ernährungsfachkraft",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Ernährungsberater", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Praxismanager/ Praxismanagerin",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC-Einzelhändler", id: "otc_retailer" },
  { value: "Pharmacist", label: "Apotheker", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Apotheke - Personal",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Schweineproduzent", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Geflügelproduzent",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Praxisinhaber (nicht Tierarzt)",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Rezeptionist / Kundenservice",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Wiederverkäufergeschäft - Personal",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Erzeuger - Gemischt/Sonstiges",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Einzelhändler",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Schafproduzent",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Tierarzt/Tierärztin",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Tierarzt/Tierärztin", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Tierarzt, Praxisinhaber",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Tierarzthelfer",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "TFA (Tiermedizinische(r) Fachangestellte(r))",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Tierarztpraxis - Sonstige",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Tierarztpraxis - Tierarzt",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Tierarztpraxis - Tierarzthelferin",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Tierarztspezialist",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Tiermedizinstudent",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Tierchirurg",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinärtechniker",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Großhändler", id: "wholesaler" },
];
const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "M.",
    value: "M.",
    id: "m",
  },
  {
    label: "Fräulein",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Herr",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Frau",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Frau",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professor",
    value: "Professor",
    id: "professor",
  },
];
export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
